
import {kindCategories, goodsType, saleType} from '@/constants/product'

export function isKindMyBiome(item: string): boolean {
  return kindCategories.kindMyBiome.includes(item);
}

export function isKindDesimone(item: string): boolean {
  return kindCategories.kindDesimone.includes(item);
}

export function isKindSubscription(item: string): boolean {
  return kindCategories.kindSubscription.includes(item) || kindCategories.kindSubscriptionStipulateMultiOpt.includes(item) || kindCategories.kindSubscriptionTtobakcareCombi.includes(item);
}

export function isKindTtobakcareLAB(item: string): boolean {
  return kindCategories.kindTtobakcareLAB.includes(item);
}

export function isKindGeneAnalysis(item: string): boolean {
  return kindCategories.kindGeneAnalysis.includes(item);
}

export function isKindO2Booster(item: string): boolean {
  return kindCategories.kindO2Booster.includes(item);
}

export function isKindCosmeticBau(item: string): boolean {
  return kindCategories.kindCosmeticBau.includes(item);
}

export function isKindStipulateMultiOpt(item: string): boolean {
  return kindCategories.kindSubscriptionStipulateMultiOpt.includes(item);
}

export function iskindSubscriptionTtobakcareCombi(item: string): boolean {
  return kindCategories.kindSubscriptionTtobakcareCombi.includes(item);
}

export function isKindPreOrder(item: string): boolean {
  return kindCategories.kindPreorder.includes(item);
}

export function isTypeSubscription(item : string) : boolean {
  return goodsType.subscription == item
}

export function isTypeNormal(item : string) : boolean {
  return goodsType.normal == item
}

export function isGroupSale(item : string) : boolean {
  return saleType.groupSale == item
}
